import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui/buttons/IconButton';
import { cn } from '@/shared/utils/cn';

type Props = {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  backTo?: string;
  right?: ReactNode;
  className?: string;
  sticky?: boolean;
};

export const PageHeader = ({
  title,
  subtitle,
  showBack = false,
  backTo,
  right,
  className,
  sticky = true,
}: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleBack = (): void => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };
  return (
    <header
      className={cn(
        'flex items-center gap-3 border-b border-slate-200 bg-white px-6 py-4',
        sticky && 'sticky top-0 z-20',
        className,
      )}
    >
      {showBack && (
        <IconButton label={t('ui.back')} variant="ghost" onClick={handleBack}>
          <ArrowLeft className="h-5 w-5" />
        </IconButton>
      )}
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-lg font-semibold text-ink lg:text-xl">{title}</h1>
        {subtitle && <p className="truncate text-sm text-ink-muted">{subtitle}</p>}
      </div>
      {right && (
        <div className="flex shrink-0 flex-wrap items-center gap-1 sm:gap-2">{right}</div>
      )}
    </header>
  );
};
